/**
 * React node views for the block-level custom nodes in the form editor.
 * These only affect what the therapist sees while editing — serialization
 * is handled by each node's renderHTML in formExtensions.js.
 */

import { NodeViewWrapper } from "@tiptap/react";
import { PencilLine, Trash, ArrowsOutLineVertical } from "@phosphor-icons/react";

const DeleteButton = ({ onClick, title = "הסר" }) => (
  <button
    type="button"
    className="ck-node-delete"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }}
    title={title}
    aria-label={title}
    contentEditable={false}
  >
    <Trash size={14} weight="bold" />
  </button>
);

export function SignatureSlotView({ node, deleteNode, selected, editor }) {
  const slotId = String(node.attrs.slotId || "1");
  const editable = editor?.isEditable;
  return (
    <NodeViewWrapper
      className={`ck-node ck-node--signature${selected ? " is-selected" : ""}`}
      data-drag-handle
    >
      <div className="signature-placeholder" data-signature-id={slotId}>
        <PencilLine size={18} weight="duotone" className="ck-node-icon" />
        <span className="signature-line" />
        <span className="signature-label">חתימת לקוח {slotId}</span>
        <span className="ck-node-hint">הלקוח יחתום כאן</span>
      </div>
      {editable && <DeleteButton onClick={deleteNode} title="הסר מקום חתימה" />}
    </NodeViewWrapper>
  );
}

export function TherapistSignatureView({ node, deleteNode, selected, editor }) {
  const editable = editor?.isEditable;
  return (
    <NodeViewWrapper
      className={`ck-node ck-node--therapist${selected ? " is-selected" : ""}`}
      data-drag-handle
    >
      <div className="therapist-signature-block">
        {node.attrs.src ? (
          <img src={node.attrs.src} className="therapist-signature-img" alt="חתימת מטפל" />
        ) : (
          <span className="ck-node-hint">חתימה חסרה</span>
        )}
        <span className="therapist-signature-label">חתימת מטפל</span>
      </div>
      {editable && <DeleteButton onClick={deleteNode} title="הסר חתימת מטפל" />}
    </NodeViewWrapper>
  );
}

export function PageBreakView({ deleteNode, selected, editor }) {
  const editable = editor?.isEditable;
  return (
    <NodeViewWrapper
      className={`ck-node ck-node--page-break${selected ? " is-selected" : ""}`}
      data-drag-handle
    >
      <div className="page-break" />
      <span className="ck-page-break-label">
        <ArrowsOutLineVertical size={12} weight="bold" />
        מעבר עמוד
      </span>
      {editable && <DeleteButton onClick={deleteNode} title="הסר מעבר עמוד" />}
    </NodeViewWrapper>
  );
}
